export default __webpack_public_path__ + "static/media/image_21.6857d452.jpg";